import React from "react";
import PropTypes from "prop-types";
//Material imports
import { useTheme, ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
//Limitless import
import { createTheme } from "../../theme/Theme";
import { createTheme as createCustomerTheme } from "../../../customer/theme/Theme";
const CustomThemeSection = ({
  children,
  themeOverrides,
  componentOverrides,
  useCustomerTheme
}) => {
  const theme = useTheme();
  let customThemeSection;
  if (useCustomerTheme) {
    customThemeSection = createCustomerTheme();
  } else {
    customThemeSection = createTheme({
      ...theme,
      components: {
        ...theme.components,
        ...componentOverrides
      }
    }, themeOverrides);
  }
  return /*#__PURE__*/React.createElement(StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: customThemeSection
  }, children));
};
export default CustomThemeSection;
CustomThemeSection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  componentOverrides: PropTypes.object,
  themeOverrides: PropTypes.object,
  useCustomerTheme: PropTypes.bool
};